<script>
import { ui } from './stores.js'

export let name;
export let style = '';
export let buttonStyle = 'darkblue';
let variableName = `showing${name[0].toUpperCase()}${name.slice(1)}`;

</script>

<button class="toolbutton" style="font-size: 2vmin; {style}  background-color: {buttonStyle};" on:click={e => { $ui[variableName] = !$ui[variableName]; }}>
    <slot />
</button>

<style>
    .toolbutton {
        font-weight: bold;
        border: 2px solid white;
        padding: 0.25vmin;
        color: white;
        background-color: darkblue;
        margin: 0;
    }
</style>